import TripRateCalculationFiltersViewModel from "../../ViewModels/TripRateCalculationFiltersViewModel";
import TripRateExportViewModel from "../../ViewModels/TripRateExportViewModel";

export default class ExportSummaryFilterViewModel {
    addUserComments: boolean = false;
    displayDirectlyToScreen: boolean = true;
    fileName: string = '';
    userComments: string = '';
    selectedSurveys: string[] = [];
    mainLandUse: string = '';
    subLandUse: string = '';
    headerIndex: number = 0;
    filters: TripRateCalculationFiltersViewModel = new TripRateCalculationFiltersViewModel();
    tripExport: TripRateExportViewModel = new TripRateExportViewModel();
}